(() => {
  const reveal = () => {
    const elements = document.querySelectorAll('.at-rv');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('in'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });

    elements.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }
})();

(() => {
  // The quick cart renders prices client-side with the theme's money format
  // ("$250.00"). Liquid-rendered prices drop trailing zeros; keep the drawer
  // consistent by stripping exact ".00" endings — never rounding real cents.
  const PRICE_SELECTOR = '.quick-cart__product-price-value, .quick-cart__product-price, .quick-cart__footer';
  const strip = (root) => {
    for (const el of root.querySelectorAll(PRICE_SELECTOR)) {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (/\d\.00(?!\d)/.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1');
        }
      }
    }
  };
  const init = () => {
    const cart = document.querySelector('.cart-flyout');
    if (!cart) return;
    strip(cart);
    new MutationObserver(() => strip(cart)).observe(cart, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

(() => {
  // Variant changes re-render the PDP price with the raw money format
  // ("$690.00"); strip exact ".00" endings the same way the quick cart does.
  const strip = (el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/\d\.00(?!\d)/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1');
      }
    }
  };
  const init = () => {
    for (const price of document.querySelectorAll('.product__price')) {
      strip(price);
      new MutationObserver(() => strip(price)).observe(price, { childList: true, subtree: true, characterData: true });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
